// Libs
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
// Components, Layouts, Pages
import { ProtectedRoute } from './components/common';
import { MainLayout } from './layouts';
import { LoadingPage } from './pages/student';
// Others
import { authRoute } from '~/utils/routes/auth';
import { RoleEnum } from './utils/enum/common';
import { publicRoutes } from './utils/routes';
import { studentRoute, privateStudentRoutes } from './utils/routes/student';
import { adminRoute, privateAdminRoutes } from './utils/routes/admin';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path='/' element={<Navigate to={`${authRoute.base}`} />}></Route>

          <Route path='/'>
            {publicRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>

          <Route element={<ProtectedRoute role={RoleEnum.STUDENT} />}>
            <Route path={studentRoute.base} element={<MainLayout />}>
              {privateStudentRoutes.map((route, index) => {
                const Page = route.component || '';
                return (
                  <Route key={index} path={route.path} element={<Page />}>
                    {route.children &&
                      route.children.length > 0 &&
                      route.children.map((childRoute, index) => {
                        const ChildComponent = childRoute.component;
                        return (
                          <Route
                            key={index}
                            path={childRoute.path}
                            index={childRoute.index ?? false}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                );
              })}
            </Route>
          </Route>

          <Route element={<ProtectedRoute role={RoleEnum.ADMIN} />}>
            <Route path={adminRoute.base} element={<MainLayout />}>
              {privateAdminRoutes.map((route, index) => {
                const Page = route.component || '';
                return (
                  <Route key={index} path={route.path} element={<Page />}>
                    {route.children &&
                      route.children.length > 0 &&
                      route.children.map((childRoute, index) => {
                        const ChildComponent = childRoute.component;
                        return (
                          <Route
                            key={index}
                            path={childRoute.path}
                            index={childRoute.index ?? false}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                );
              })}
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
